import type { Gym } from "../api/hooks";

const DAY_MAP: Record<string, string> = {
  mon: "Monday",
  tue: "Tuesday",
  wed: "Wednesday",
  thu: "Thursday",
  fri: "Friday",
  sat: "Saturday",
  sun: "Sunday",
};

export function gymLocalBusiness(gym: Gym) {
  const openingHours = Object.entries(gym.openingHours).flatMap(([day, ranges]) =>
    (ranges as [string, string][]).map(([open, close]) => ({
      "@type": "OpeningHoursSpecification",
      dayOfWeek: DAY_MAP[day],
      opens: open,
      closes: close,
    })),
  );

  const [street, postalCity] = gym.address.split(",").map((s) => s.trim());
  const postalMatch = postalCity?.match(/^(\d{5})\s+(.+)$/);

  return {
    "@context": "https://schema.org",
    "@type": "SportsActivityLocation",
    "@id": `https://www.crossfit-heracles.fr/#${gym.slug}`,
    name: gym.name,
    telephone: gym.phone,
    email: gym.email ?? undefined,
    url: `https://www.crossfit-heracles.fr/plannings/${gym.slug}`,
    address: {
      "@type": "PostalAddress",
      streetAddress: street,
      postalCode: postalMatch?.[1],
      addressLocality: postalMatch?.[2],
      addressCountry: "FR",
    },
    geo: gym.latitude && gym.longitude
      ? { "@type": "GeoCoordinates", latitude: gym.latitude, longitude: gym.longitude }
      : undefined,
    openingHoursSpecification: openingHours,
    priceRange: "€€",
  };
}
